import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { set } from '../../actions/breadcrumbs.actions';
import {
  ADMIN_SCHOOL_AGODI_BRANCHES_BREADCRUMBS,
  ADMIN_SCHOOL_BRANCHES_BREADCRUMBS,
  ADMIN_SCHOOL_COMMUNITY_BREADCRUMBS,
  ADMIN_SCHOOL_MANAGEMENT_BREADCRUMBS,
  ADMIN_SCHOOL_SCHOOLS_BREADCRUMBS
} from '../../constants/breadcrumbs.constants';
import { ADMIN_SCHOOL_AGODI_BRANCHES_RESOURCE } from '../../resources/admin/admin.school.agodi.branches.resource';
import { ADMIN_SCHOOL_BRANCHES_RESOURCE } from '../../resources/admin/admin.school.branches.resource';
import { ADMIN_SCHOOL_COMMUNITY_RESOURCE } from '../../resources/admin/admin.school.community.resource';
import { ADMIN_SCHOOL_MANAGEMENT_RESOURCE } from '../../resources/admin/admin.school.management.resource';
import { ADMIN_SCHOOL_SCHOOLS_RESOURCE } from '../../resources/admin/admin.school.schools.resource';
import { fetchedSelector, fetchingSelector } from '../../selectors/fetch.selectors';
import { tableMetaSelector } from '../../selectors/resources.selectors';

const BREADCRUMBS_BY_RESOURCE = {
  [ADMIN_SCHOOL_MANAGEMENT_RESOURCE.key]: ADMIN_SCHOOL_MANAGEMENT_BREADCRUMBS,
  [ADMIN_SCHOOL_COMMUNITY_RESOURCE.key]: ADMIN_SCHOOL_COMMUNITY_BREADCRUMBS,
  [ADMIN_SCHOOL_SCHOOLS_RESOURCE.key]: ADMIN_SCHOOL_SCHOOLS_BREADCRUMBS,
  [ADMIN_SCHOOL_BRANCHES_RESOURCE.key]: ADMIN_SCHOOL_BRANCHES_BREADCRUMBS,
  [ADMIN_SCHOOL_AGODI_BRANCHES_RESOURCE.key]: ADMIN_SCHOOL_AGODI_BRANCHES_BREADCRUMBS
};

export const useSetBreadcrumbs = (resourceKey) => {
  const dispatch = useDispatch();
  const params = useParams();
  const isFetching = useSelector((state) => fetchingSelector(state, { resource: { key: resourceKey } }));
  const isFetched = useSelector((state) => fetchedSelector(state, { resource: { key: resourceKey } }));
  const meta = useSelector((state) => tableMetaSelector(state, { resource: { key: resourceKey } }));

  useEffect(() => {
    if (!isFetched || isFetching) {
      dispatch(set(BREADCRUMBS_BY_RESOURCE[resourceKey].LOADING()));
    } else {
      dispatch(
        set(
          BREADCRUMBS_BY_RESOURCE[resourceKey].LOADED({
            netId: params?.netId,
            managementId: params?.managementId,
            communityId: params?.communityId,
            schoolId: params?.schoolId,
            branchId: params?.branchId,
            netName: meta?.netName,
            managementName: meta?.managementName,
            communityName: meta?.communityName,
            schoolName: meta?.schoolName,
            branchName: meta?.branchName
          })
        )
      );
    }
  }, [
    dispatch,
    resourceKey,
    params?.netId,
    params?.managementId,
    params?.communityId,
    params?.schoolId,
    params?.branchId,
    meta?.netName,
    meta?.managementName,
    meta?.communityName,
    meta?.schoolName,
    meta?.branchName,
    isFetched,
    isFetching
  ]);
};
